import React from "react";
import { pagelayout } from "../../../../assets/advertflair";

function AdvertflairHeader() {
  const desktopHeader = pagelayout.find(
    (item) => item.name === "desktopHeader"
  ).link;

  const mobileHeader = pagelayout.find(
    (item) => item.name === "mobileHeader"
  ).link;
  return (
    <div className="w-screen sticky top-0 z-10">
      <img className="hidden md:flex" src={desktopHeader} alt="" />
      <img className="md:hidden" src={mobileHeader} alt="" />
    </div>
  );
}

export default AdvertflairHeader;
